/*eslint quote-props: off*/
const tr = {
  cards: {
    attributes: {
      name:           'Título',
      description:    'Descrição',
      bg_color:       'Cor de fundo',
      text_color:     'Cor da descrição',
      title_color:    'Cor de título',
      link_color:     'Cor do link',
      type:           'Tipo',
      sorter:         'Ordenação',
      lang:           'Idioma',
      url:            'Link de Url',
      is_active:      'Ativo',
      created_at:     'Criado em',
      updated_at:     'Atualizado em',
      archive_id:     'ID de arquivo',
      image:          'Imagem',
      image_base64:   'Imagem',
    },
    defSingular:      'Card',
    defPlural:        'Cards',
  },
};

export default tr;
